<template>
  <div class="container">
    <el-tooltip
      class="item"
      effect="dark"
      content="帮助文档"
      placement="bottom"
    >
      <i class="el-icon-question" @click="seeHelpManual()"></i>
    </el-tooltip>
    <!-- pdf预览弹框 -->
    <el-dialog
      title="帮助文档"
      :visible.sync="viewVisible"
      width="80%"
      height="100%"
      :fullscreen="true"
    >
      <help-modules></help-modules>
    </el-dialog>
  </div>
</template>
<script>
import HelpModules from "./helpmoduls.vue";
export default {
  name: "HelpManual",
  components: { HelpModules },
  data() {
    return {
      viewVisible: false
    };
  },
  created() {},
  methods: {
    seeHelpManual() {
      this.viewVisible = true;
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  padding-right: 20px;
  /deep/ .el-dialog__body {
    height: calc(100vh - 80px) !important;
    padding: 0px !important;
  }
  /deep/ .el-dialog__header {
    text-align: center !important;
  }
}
</style>
